<script setup lang="ts">
const { dense = false, percentage } = defineProps<{
  dense?: boolean
  percentage: number
}>()

// Clamp the display percentage to a minimum of 1% to match the design requirement
// of showing the smallest amount of blue in the empty state.
const displayPercentage = Math.min(Math.max(percentage, 1), 100)
</script>
<template>
  <div
    class="rounded-pill bg-pwt_off_white flex-grow-1 flex-shrink-1"
    :style="`
        width: 100%;
        height: ${dense ? '5px' : '8px'};
        box-shadow: inset -2px 3px 2px rgba(0, 0, 0, 0.2);
        overflow: hidden;`"
  >
    <div
      class="bg-pwt_azure_60 rounded-pill"
      :style="{
        width: `${displayPercentage}%`,
        height: '100%',
        minWidth: '18px',
      }"
    ></div>
  </div>
</template>
